import React, { useEffect, useState, useRef, useContext } from "react";
import { ViewContext } from "./contexts/ViewContext";

import mapboxgl from "mapbox-gl";
import { Button, Grid } from "@mui/material";

mapboxgl.accessToken =
    "pk.eyJ1Ijoicm91dGU0dSIsImEiOiJjaW5rYXV1bmgwMDZtdnZseTh0Z2l5azFnIn0.SjjQEIHK2qF7JR5BN3xgWg";

export default function ObstacleLocation() {
    const { view, dispatch } = useContext(ViewContext);

    const mapContainer = useRef(null);
    const map = useRef(null);
    const [zoom, setZoom] = useState(18);
    const [coords, setCoords] = useState(null);
    useEffect(() => {
        navigator.geolocation.getCurrentPosition(function (position) {
            //setCoords(position.coords);
            //setLng(coords.longitude);
            //setLat(coords.latitude);
            setCoords({ latitude: 50.7974455, longitude: -1.0919753 });
            //setCoords({latitude: 47.0887798, longitude: 17.90556662});
            console.log(position.coords);
        });
    }, []);

    useEffect(() => {
        if (map.current) return; // initialize map only once
        if (!coords) return; // initialize only when location is available
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/route4u/cir4yu7c6001bchm4snxh67mt",
            center: [coords.longitude, coords.latitude],
            zoom: zoom,
        });
        console.log(mapContainer.current);
    }, [coords, zoom]);

    useEffect(() => {
        if (!map.current) return; // wait for map to initialize
        map.current.on("move", () => {
            setZoom(map.current.getZoom().toFixed(2));
        });
    });

    return (
        <div>
            <p>
                {view.locale === "hu"
                    ? "Válaszd ki pontosan az akadály helyét! Kerüljön a körbe!"
                    : view.locale === "en" &&
                      "Please drag the map that the exact location of the obstacle is in the circle!"}
            </p>
            <div ref={mapContainer} style={{ width: "100%", height: "300px" }}>
                <div
                    style={{
                        zIndex: 9999,
                        border: "3px solid gray",
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        position: "absolute" /*Can also be `fixed`*/,
                        left: "0",
                        right: "0",
                        top: "0",
                        bottom: "0",
                        margin: "auto",
                    }}
                ></div>
            </div>
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="center"
                style={{ marginTop: "16px" }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                        dispatch({ type: "CHANGE PAGE", direction: 1 })
                    }
                >
                    {view.locale === "hu"
                        ? "Akadály jelentése"
                        : view.locale === "en" && "Report obstacle"}{" "}
                </Button>
            </Grid>
        </div>
    );
}
